import {
    createContext,
    FC,
    useState,
    useContext,
    PropsWithChildren,
    ReactNode,
    useMemo,
    useCallback,
  } from "react";
    import { MetricsFilters } from "@/types/metrics";

  const noop = () => null;

  const getDefaultStartDate = (d: Date) => {
    const date = new Date(d);
    const day = date.getDay();
    const diff = date.getDate() - day + (day === 0 ? -6 : 1);

    return date.setDate(diff), date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
  };

  const getDefaultEndDate = (d: Date) => {
    const date = new Date(d);
    const day = date.getDay();
    const diff = date.getDate() - day + (day === 0 ? -6 : 1) + 4;

    return date.setDate(diff), date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
  };

  const defaultValues =
  {
    filters: {
        orderNames: [],
        insurances: [],
        assignedUsers: [],
        performDateRangeStart: getDefaultStartDate(new Date),
        performDateRangeEnd: getDefaultEndDate(new Date),
        sortCriteria: undefined,
        sortOrder: null
    },
    updateFilters: noop,
    };

    export interface Metrics {
        filters: MetricsFilters;
        updateFilters: (partial: Partial<MetricsFilters>) => void;
    }

    const MetricsContext = createContext<Metrics>(defaultValues);

    export const MetricsContextProvider: FC<PropsWithChildren<ReactNode>> = ({ children }) => {
        const [filters, setFilters] = useState<MetricsFilters>(defaultValues.filters);

      const updateFilters = useCallback(
        (changes: Partial<MetricsFilters>, values?: string[]) => {
          values ?
            setFilters({ ...filters, [String(changes)]: values }) :
            setFilters({ ...filters, ...changes });

          }, [filters]);

        const values = useMemo(
            () => ({
              filters,
              updateFilters,
            }),
            [
              filters,
              updateFilters,
            ],
          );

        return (<MetricsContext.Provider value={values}>{children}</MetricsContext.Provider>);
    };

    export const useMetricsContext = () => useContext(MetricsContext);
